import { render, staticRenderFns } from "./EditAiModelDialog.vue?vue&type=template&id=67be23c4"
import script from "./EditAiModelDialog.vue?vue&type=script&lang=js"
export * from "./EditAiModelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports